import React from "react";
import logoFacebook from "../assets/facebook.png";
import logoTwitter from "../assets/twitter.png";
import logoLinkedin from "../assets/linkedin.png";
import { Link } from "@bwevents/components";

import "./Share.scss";

export default function Share({ url = "" }) {
  const origin = window.location.origin;

  const facebook =
    "https://www.facebook.com/sharer/sharer.php?u=" + origin + url;
  const twitter = "https://twitter.com/intent/tweet?url=" + origin + url;
  const linkedin =
    "https://www.linkedin.com/sharing/share-offsite/?url=" + origin + url;

  return (
    <div className="share-url">
      <Link href={linkedin} className="bw-event-btn">
        <img src={logoLinkedin} alt="linkedin" />
      </Link>
      <Link href={facebook} className="bw-event-btn">
        <img src={logoFacebook} alt="facebook" />
      </Link>
      <Link href={twitter} className="bw-event-btn">
        <img src={logoTwitter} alt="twitter" />
      </Link>
    </div>
  );
}
